import { currencyMenuStyles as currencyStyle } from "@insite/content-library/Widgets/Common/CurrencyMenu";
import { headerSignInStyles as signInStyle } from "@insite/content-library/Widgets/Common/HeaderSignIn";
import { languageMenuStyles as languageStyle } from "@insite/content-library/Widgets/Common/LanguageMenu";
import { IconPresentationProps } from "@insite/mobius/Icon";
import { SelectPresentationProps } from "@insite/mobius/Select";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import getColor from "@insite/mobius/utilities/getColor";
import { secondaryNavigationStyles as secondaryNav } from "@waytek/Overrides/Widgets/Header/SecondaryNavigation";
import { colorStrings } from "@waytek/Utilities/variables";
import { css } from "styled-components";

secondaryNav.headerWrapper = {
    css: css`
        background-color: ${getColor(colorStrings.commonGlobalFadedTaupe)};

        & > div {
            background-color: transparent;
            padding: 0 20px;
            margin: auto;
            max-width: 1220px;
            text-transform: none;
        }
    `,
};

secondaryNav.warehousePickupLink = {
    css: css`
        display: none;
    `,
};

const iconStyle = (style: TypographyPresentationProps | IconPresentationProps | undefined): any => ({
    ...style,
    color: colorStrings.secondaryMain,
});

const selectStyle = (style: SelectPresentationProps | undefined) => ({
    ...style,
    cssOverrides: {
        ...style?.cssOverrides,
        inputSelect: css`
            ${style?.cssOverrides?.inputSelect}
            color: ${getColor(colorStrings.secondaryMain)};
            text-transform: none;
        `,
    },
});

// Common/CurrencyMenu Widget
currencyStyle.currencySymbol = {
    ...iconStyle(currencyStyle.currencySymbol),
};

currencyStyle.currencySelect = {
    ...selectStyle(currencyStyle.currencySelect),
};

// Common/LanguageMenu Widget
languageStyle.languageIcon = {
    ...iconStyle(languageStyle.languageIcon),
};

languageStyle.languageSelect = {
    ...selectStyle(languageStyle.languageSelect),
};

// Common/HeaderSignIn Widget
signInStyle.titleClickable = {
    ...signInStyle.titleClickable,
    css: css`
        &:hover {
            ${TypographyStyle} {
                text-decoration: underline;
            }
        }
    `,
};

signInStyle.titleIcon = {
    ...iconStyle(signInStyle.titleIcon),
};

signInStyle.titleTypography = {
    ...signInStyle.titleTypography,
    transform: "none",
    ellipsis: false,
    css: css`
        ${signInStyle.titleTypography?.css}
        margin-left: 6px;
        max-width: 100%;
    `,
    color: colorStrings.secondaryMain,
};

signInStyle.signOutClickable = {
    ...signInStyle.signOutClickable,
    css: css`
        ${signInStyle.signOutClickable?.css}
        color: ${getColor(colorStrings.secondaryMain)};
        margin-left: 40px;
        text-transform: none;

        &:hover {
            text-decoration: underline;
        }
    `,
};
